import EditOutlined from '@mui/icons-material/EditOutlined';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

interface SettingsListEditButtonProps {
  onEdit: () => void;
}

export default function SettingsListEditButton({ onEdit }: SettingsListEditButtonProps) {
  return (
    <Tooltip title="Засах">
      <IconButton color="primary" size="small" aria-label="Засах" onClick={onEdit}>
        <EditOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
